class EniolaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll("[data-eniola-slide]"));
    this.dots = Array.from(this.querySelectorAll("[data-eniola-dot]"));
    this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains("is-active")));

    if (this.slides.length < 2) return;

    this.querySelector("[data-eniola-previous]")?.addEventListener("click", () => this.show(this.currentIndex - 1));
    this.querySelector("[data-eniola-next]")?.addEventListener("click", () => this.show(this.currentIndex + 1));
    this.dots.forEach((dot, index) => dot.addEventListener("click", () => this.show(index)));

    this.addEventListener("mouseenter", () => this.stop());
    this.addEventListener("mouseleave", () => this.start());
    this.addEventListener("focusin", () => this.stop());
    this.addEventListener("focusout", () => this.start());
    document.addEventListener("visibilitychange", () => document.hidden ? this.stop() : this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  show(index) {
    const nextIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", String(!isActive));
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === nextIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });

    this.currentIndex = nextIndex;
  }

  start() {
    if (this.dataset.autoplay !== "true" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.currentIndex + 1), Number(this.dataset.interval) * 1000);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }
}

if (!customElements.get("eniola-hero")) {
  customElements.define("eniola-hero", EniolaHero);
}

class EniolaSiteHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector("[data-eniola-menu-toggle]");
    this.menu = this.querySelector("[data-eniola-mobile-menu]");
    if (!this.toggle || !this.menu) return;

    this.toggle.addEventListener("click", () => this.setOpen(this.menu.hidden));
    this.menu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => this.setOpen(false)));

    this.handleEscape = (event) => {
      if (event.key === "Escape") this.setOpen(false);
    };
    document.addEventListener("keydown", this.handleEscape);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleEscape);
  }

  setOpen(open) {
    this.menu.hidden = !open;
    this.toggle.setAttribute("aria-expanded", String(open));
    this.classList.toggle("is-open", open);
    document.documentElement.classList.toggle("eniola-menu-open", open);
  }
}

if (!customElements.get("eniola-site-header")) {
  customElements.define("eniola-site-header", EniolaSiteHeader);
}

const setupEniolaLexicon = (scope = document) => {
  scope.querySelectorAll(".eniola-lexicon").forEach((lexicon) => {
    if (lexicon.dataset.ready === "true") return;
    lexicon.dataset.ready = "true";

    const input = lexicon.querySelector("[data-eniola-lexicon-search]");
    const items = Array.from(lexicon.querySelectorAll("[data-eniola-lexicon-item]"));
    const count = lexicon.querySelector("[data-eniola-lexicon-count]");
    const empty = lexicon.querySelector("[data-eniola-lexicon-empty]");
    if (!input) return;

    input.addEventListener("input", () => {
      const query = input.value.trim().toLocaleLowerCase("de");
      let visible = 0;

      items.forEach((item) => {
        const matches = item.dataset.search.includes(query);
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (count) count.textContent = `${visible} ${visible === 1 ? "Zutat" : "Zutaten"}`;
      if (empty) empty.hidden = visible !== 0;
    });
  });
};

setupEniolaLexicon();
document.addEventListener("shopify:section:load", (event) => setupEniolaLexicon(event.target));
